module.exports = __webpack_public_path__ + "img/arrow_left_outline_white.db90de49.png";